import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards";

export default function AssetProtectionServices() {

    return (
        <main className='main'>
            <IntroSection
                title="Asset Protection Services"
                subtitle="Safeguard Your Wealth. Protect Your Future."
                description="At Offshore Advisory, we provide robust, legally compliant asset protection strategies to preserve your wealth from risks, lawsuits, political instability, and creditor claims. Whether you own business assets, property, intellectual property, crypto holdings, or investment portfolios — our global solutions are tailored to your needs."
                badges={[
                    "Trust & Foundations",
                    "Corporate Structuring",
                    "Strong Legal Safeguards"
                ]}
                buttonText="Request an Asset Protection Consultation →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/asset-protection/asset-protection.png')}
                imageAlt="Asset Protection Services"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Asset Protection Matters"
                        subtitle='Modern business and personal life carry risks — litigation, regulatory changes, creditor claims, political upheaval, and even cyber threats. Without proper structuring, your assets may be unprotected. Smart individuals and companies proactively protect their holdings. Key benefits:'
                        blocks={[
                            {
                                items: [
                                    { text: "Shield from Creditors & Lawsuits" },
                                    { text: "Jurisdictional Diversification" },
                                    { text: "Privacy & Confidentiality" },
                                    { text: "Legal Compliance & Peace of Mind" },
                                    { text: "Protection from Political or Economic Instability" },
                                    { text: "Preserve Wealth for Generations" }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Core Asset Protection Services"
                        blocks={[
                            {
                                items: [
                                    { title: "Trusts & Foundations", text: "Create offshore or onshore trusts and foundations to hold assets securely, with layers of separation between ownership and control." },
                                    { title: "Holding & Holding Structures", text: "Use holding companies or multi-tier corporate structures so risk exposure is compartmentalized across separate legal entities." },
                                    { title: "Intellectual Property (IP) Holding", text: "Move IP (brands, patents, software) into a dedicated entity, licensing back usage to protect it from operational liabilities." },
                                    { title: "Offshore Banking & Custodial Services", text: "Place funds into secure jurisdictions or specialized custodian entities, adding another protective layer." },
                                    { title: "Real Estate & Property Hedging", text: "Use asset-holding structures to own real estate through separate entities, shielding them from business risk or litigation." },
                                    { title: "Captive Insurance", text: "In certain jurisdictions, setting up a captive insurance company helps manage risk internally and reduce external exposure." },
                                    { title: "Estate & Succession Planning", text: "Design a plan for transfer of wealth through legal instruments — minimizing estate taxes and preventing disputes." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="How Our Process Works"
                        blocks={[
                            {
                                items: [
                                    { text: "Initial Consultation & Risk Assessment — review asset types, jurisdiction, risk exposure, and goals." },
                                    { text: "Design of Protection Structure — propose optimal vehicles: trusts, foundations, holdings, IP structures." },
                                    { text: "Entity Formation & Documentation — incorporate required entities, draft trust/foundation documents, license agreements, and contracts." },
                                    { text: "Asset Transfer & Implementation — migrate assets (cash, IP, real estate) into the new structure legally and with compliance." },
                                    { text: "Ongoing Monitoring & Compliance — ensure all structures stay compliant, file updates, renewals, and audits." },
                                    { text: "Periodic Review & Adjustment — optimize the structure as regulations or portfolio evolves." },
                                    { text: "⏱ Typical timeframe: 4–8 weeks for a basic structure (varies by complexity)." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Jurisdictions & Legal Safe Havens"
                        blocks={[
                            {
                                items: [
                                    { text: "Cayman Islands" },
                                    { text: "British Virgin Islands (BVI)" },
                                    { text: "Mwali / Anjouan" },
                                    { text: "Panama" },
                                    { text: "Mauritius" },
                                    { text: "Switzerland" },
                                    { text: "Malta" },
                                    { text: "Singapore" }
                                ]
                            }
                        ]}
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Protect what you’ve built."
                        description="Let our experts design and implement a rock-solid asset protection plan tailored to your specific needs."
                        buttonText="Book Your Protection Strategy Session →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is asset protection legal?",
        answer: "Yes — asset protection involves legal structuring, not fraud. We use legitimate tools (trusts, foundations, company structures) that comply with laws.",
    },
    {
        question: "Can I keep control over my assets?",
        answer: "Yes. Many structures allow you to retain beneficial control through trustee mechanisms or contractual arrangements.",
    },
    {
        question: "What types of assets can I protect?",
        answer: "Funds, real estate, intellectual property, business shares, crypto holdings, artwork, and more.",
    },
    {
        question: "How much does this cost?",
        answer: "Costs vary widely based on structure complexity, jurisdictions involved, and asset size. We provide tailored quotes after analysis.",
    },
    {
        question: "Will tax authorities consider this tax evasion?",
        answer: "No — compliant asset protection includes proper legal disclosure and tax compliance. We always structure to stay within regulatory boundaries.",
    },
];



const testimonialsData = [
    {
        quote: "Offshore Advisory helped me rebuild my structure after a lawsuit threat, and my assets are now protected and peace of mind restored.",
        author: "John D.",
        role: "Tech Entrepreneur"
    },
    {
        quote: "Their trust + holding setup saved my real estate portfolio from business liability. Highly professional.",
        author: "Maria N.",
        role: "Property Investor"
    }
];
